import { thumb1 } from './images/thumbs'
import { slide1, slide2, slide4 } from './images/slides'

export default {
    container: {
        height: window.innerHeight,
        backgroundSize: 'cover',
        backgroundPosition: 'right',
    },
    tomatoBG: {
        backgroundImage: `url("${slide1}")`,
    },
    redPepperBG: {
        backgroundImage: `url("${slide2}")`,
    },
    greenPepperBG: {
        backgroundImage: `url("${slide4}")`,
    },
    overlay: {
        padding: '0 30 0 30',
    },
    overlayDark: {
        backgroundColor: 'rgba(86, 86, 86, 0.4)',
        padding: '0 30 0 30',
    },
    content: {
        height: window.innerHeight,
    },
    subcontent: {
        height: window.innerHeight,
        alignItems: 'center',
        justifyContent: 'center',
    },
    header: {
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: '500',
        fontSize: '200%',
    },
    description: {
        margin: '0 30 0 30',
        color: 'white',
        lineHeight: '150%',
    },
    button: {
        padding: '5 15 5 15',
        backgroundColor: 'transparent',
        borderStyle: 'solid',
        borderColor: 'white',
        color: 'white',
        borderRadius: 100,
    },
}



// WEBPACK FOOTER //
// ./src/views/Splash/styles.js